import angular from 'angular';

import * as actions from '../../../store/actions';

const mapStateToScope = (state) => ({});

/**
 * @ngdoc function
 * @name myConsultApp.controller:deactivationsController
 * @description
 * # deactivationsController
 * Controller of the myConsultApp
 */
angular
  .module('myConsultApp')
  .controller('deactivationsController', ($ngRedux, $scope, $rootScope, $timeout, $http, ENV) => {
    $scope.init = () => {
      $scope.unsubscribe = $ngRedux.connect(mapStateToScope, actions)($scope);
    };

    $scope.clearDeactivationsDetail = () => {
      $scope.isDeactivationsActionMenu = false;
      $scope.deactivationsTable = null;
      $scope.rescanConfirmation = false;
    };

    $scope.clearDeactivationsDetail();

    $scope.close = () => {
      $rootScope.isDeactivationsDisplay = false;
      $rootScope.closeComponent();
    };

    $scope.generateUserRoute = () => {
      return `${$rootScope.routes.user}/${$scope.user.id}`;
    };

    $scope.setTable = () => {
      $scope.deactivationsTable = {
        name: 'Deactivations',
        options: {
          endpoint: '/2.0/users/' + $rootScope.userId + '/deactivations/',
          endpoint_data_key: 'deactivations',
          id_prefix: 'deactivation',
          per_page_options: [15, 25, 50, 100, 200],
          records_per_page: 15,
          row_style: 'standard',
          scale_up: true,
          search_key: 'Deactivations',
          search_required: false,
        },
        actions: [],
        columns: [
          {
            name: 'ID',
            options: {
              content: '{{ record.id }}',
              class: '',
            },
          },
          {
            name: 'Completed',
            options: {
              content: '{{ record.deactivation_completed || "Not Completed" }}',
              class: '',
            },
          },
          {
            name: 'Updated',
            options: {
              content: '{{ record.updated || "" }}',
              class: '',
            },
          },
          {
            name: 'Requested On/Created',
            options: {
              content: '<strong style="font-weight:bold">Requested On:</strong> {{ record.requested_on || "" }}<br /><strong style="font-weight:bold">Created:</strong> {{ record.created || "" }}',
              class: '',
            },
          },
          {
            name: 'Requested By',
            options: {
              content:
                '<span ng-if="record.requested_by.first_name || record.requested_by.last_name">' +
                '{{ record.requested_by.first_name || "" }} {{ record.requested_by.last_name || "" }}</span>' +
                '<br ng-if="(record.requested_by.first_name || record.requested_by.last_name) && record.requested_by.contact_information.email"/>' +
                '<span ng-if="record.requested_by.contact_information.email">' +
                '{{ record.requested_by.contact_information.email || "" }}</span>',
              class: '',
            },
          },
          {
            name: 'Included Anonymization',
            options: {
              content:
                '<a href="#" ng-if="record.included_anonymization" ng-click="onDisplayAnonymizationDetail({ userId: $root.userId, anonymizationId: record.included_anonymization.id })">View Anonymization Detail</a>'+
                '<span ng-if="!record.included_anonymization">Deactivation Only</span>' +
                '<span ng-if="record.included_anonymization && record.included_anonymization.anonymization_completed"><br /><strong style="font-weight:bold">Anonymization Completed On:</strong><br />{{ record.included_anonymization.anonymization_completed }}</span>',
              class: '',
            },
          },
          {
            name: 'Deactivation Status',
            options: {
              content:
                '<a href="#" ng-click="onDisplayDeactivationDetail({ userId: $root.userId, deactivationId: record.id });">View Deactivation Detail</a>',
              class: '',
            },
          },
        ],
        filters: [
          {
            name: 'Deactivation Completed',
            type: 'multiple_choice',
            options: {
              choices: {
                Completed: { type: 'standard', state: true, value: 'true', order: 0 },
                'Not Compelted': { type: 'standard', state: true, value: 'false', order: 1 },
              },
              class: '',
              query_string_parameter: 'deactivation_completed',
              select_all: true,
            },
          },
          {
            name: 'Anonymization Status',
            type: 'multiple_choice',
            options: {
              choices: {
                'Included Anonymization': { type: 'standard', state: true, value: 'true', order: 0 },
                'Deactivation Only': { type: 'standard', state: true, value: 'false', order: 1 },
              },
              class: '',
              query_string_parameter: 'included_anonymization',
              select_all: true,
            },
          },
          {
            name: 'Timeframe',
            type: 'single_choice',
            options: {
              choices: {
                'Last 24 Hours': { type: 'standard', state: false, value: 'day', order: 0 },
                'Previous Week': { type: 'standard', state: true, value: 'week', order: 1 },
                'Previous 365 Days': { type: 'standard', state: false, value: 'year', order: 2 },
                All: { type: 'standard', state: false, value: 'all', order: 3 },
                'Custom Range': {
                  type: 'range',
                  state: false,
                  value: 'range',
                  from: '',
                  to: '',
                  date_field: true,
                  order: 4,
                  error: false,
                },
              },
              class: 'timeframe-filter above-divider',
              query_string_parameter: 'timeframe',
            },
          },
        ],
        sort_options: {
          deactivation_completed: {
            state: true,
            value: '-1',
            title: 'Deactivation Completed',
            order: 0,
          },
          requested_on: {
            state: false,
            value: '-1',
            title: 'Requested On',
            order: 1,
          },
          updated: {
            state: false,
            value: '-1',
            title: 'Updated',
            order: 2,
          },
          created: {
            state: false,
            value: '-1',
            title: 'Created',
            order: 3,
          },
        },
      };
    };

    const componentVisibleListener = $rootScope.$watch('componentOpened', () => {
      if (!$rootScope.componentOpened) {
        $scope.clearDeactivationsDetail();
      }
    });

    const userIdListener = $rootScope.$watch('isDeactivationsDisplay', () => {
      if ($rootScope.isDeactivationsDisplay && $rootScope.userId) {
        $scope.setTable();
      } else {
        $scope.clearDeactivationsDetail();
      }
    });

    $scope.init();

    $scope.$on('$destroy', () => {
      $scope.unsubscribe();
      componentVisibleListener();
      userIdListener();
    });
  })
  .directive('deactivations', () => {
    return {
      templateUrl: 'templates/v2/deactivations.html',
    };
  });
